module.exports = "<div #subscriberDiv></div>\n"